<script setup lang="ts">
// Depósito recusado (status `error` do /wallet/charge): titularidade
// divergente — a conta que pagou é de outro CPF. Nenhum valor é debitado.
// Mesmo conteúdo do fluxo antigo (components/deposit/result/Denied.vue),
// redesenhado na paleta do modal novo.

type Emits = {
  retry: [];
  close: [];
};

const emit = defineEmits<Emits>();
</script>

<template>
  <div class="gdm-denied">
    <div class="gdm-denied-badge">
      <svg
        aria-hidden="true"
        fill="none"
        height="26"
        viewBox="0 0 16 16"
        width="26"
      >
        <path
          d="M3 3l10 10M13 3L3 13"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-width="2"
        />
      </svg>
    </div>

    <p class="gdm-denied-title">
      {{ $t('account.wallet.deposit_denied.title') }}
    </p>

    <p class="gdm-denied-subtitle">
      {{ $t('account.wallet.deposit_denied.subtitle') }}
    </p>

    <div class="gdm-denied-tip">
      <NuxtIcon
        class="gdm-denied-tip-icon"
        name="toaster/warning"
      />
      <span>{{ $t('account.wallet.deposit_denied.tip') }}</span>
    </div>

    <button
      class="gdm-denied-retry"
      type="button"
      @click="emit('retry')"
    >
      {{ $t('account.wallet.deposit_denied.retry') }}
    </button>

    <button
      class="gdm-denied-close"
      type="button"
      @click="emit('close')"
    >
      {{ $t('account.wallet.deposit_denied.close') }}
    </button>
  </div>
</template>

<style scoped lang="scss">
$red: #fb4e6d;
$orange: #ff3700;

.gdm-denied {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding-top: 4px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  text-align: center;
}

.gdm-denied-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 76px;
  height: 76px;
  border-radius: 9999px;
  background: rgba(251, 78, 109, 0.12);
  color: $red;
}

.gdm-denied-title {
  margin-top: 6px;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
}

.gdm-denied-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  line-height: 18px;
}

.gdm-denied-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 11px;
  border-radius: 12px;
  background: rgba(245, 158, 11, 0.15);
  color: #fbbf24;
  font-size: 12px;
  line-height: 16px;
  text-align: left;
}

.gdm-denied-tip-icon {
  flex-shrink: 0;
}

.gdm-denied-retry {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  margin-top: 8px;
  border-radius: 12px;
  background: $orange;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.gdm-denied-close {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  cursor: pointer;
}
</style>
